import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Conda is not just for Python.`}</p>
    <h1>{`Conda`}</h1>
    <p>{`Conda is a cross-platform, language-agnostic binary package manager. Shame for me 😟, it's there for years, but only recently I've realized how awesome it is! Maybe Anaconda's daunting fat distribution scares away people like me. Anyhow, with `}<a parentName="p" {...{
        "href": "https://conda.io/miniconda.html"
      }}>{`MiniConda`}</a>{` you can manage virtual environment of your `}{`*`}{`nix packages. If you works on app level development (not OS related), you can easily make almost every standard linux dev package `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`virtual`}</code>{`. This is super useful if you're not sudoer or in big tech giants (which usually has their own package mangers) but want to do something big or you don't like heavy rocket-launcher solutions (`}<a parentName="p" {...{
        "href": "https://www.docker.com/"
      }}>{`Docker`}</a>{`/`}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Virtual_machine"
      }}>{`VirtualMachine`}</a>{`). Actually, inside conda's `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`x86_64-conda_*-linux-gnu/sysroot`}</code>{`, you can build your own `}{`*`}{`nix kingdom or miniverse.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/106733e904a7d41252442d899c5c2e97/29114/miniverse.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.99999999999999%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAIAAADwazoUAAAACXBIWXMAAAsTAAALEwEAmpwYAAACqklEQVQozwGfAmD9AIqAS21gN25fNXRkOnJkN1xOLWFWO29jRH9wRH5oMYSFcKCxrXJuU2xdMom2bGfZjG1/UY1+SYJ5R25iOQD28ZnQwn61yImm1JjU0Yu2qWyJf2CPf1uAdU53dVKlt7LKztLBwqTY1ISH3ZBR0Y2k24z76Jbc1omnl10Ax7yAybiEf7iLSLlkos+MvseVfHlfmpZqjphlcmE0kYt7xLav1tCX4NWNhLd5db9ww9B73MyL7eWcuqpuAM/FhMC0ho3TmFmvYp3Oi87GinhpSaOYYZ+RU2RHFol/bLnFwOngmfLjma22cW2wac25YdjIhPjxoLmqagDj2X6/rXCKpWdCtGFtq2GumVzFrpTFro9rZ0RUSyu9vrbH5OzQxJDWx3POt2Wfu2jbulvYyW/Yy3Csm10AgnVIi4BKZnxQZYNcaHRPk41h9My+2bimZlQwXUIcz8/MmMzBoqVnqaFekKFZ2MNlb5dcmJlXopVWiXtIAL6qg5STcjBbTlxxX19uXY2Ua/bhhLusbWZ1TE9+YGitoEepgW+rc3WUbHmXY6i0bWOjXIGcZ7WndaygbgChkVprclAvTElOYlBAX05wdFDy7nqlt41mm4JAyKhX0atm07JIyapCv55ak3mmtJJUnm2FoWjCtHbKvX8AgXFDYWhGSmJXX2dVU2hTbWxT3814andiQ4OATN+0b/TIgPTJUuq8T+K3PXRudH1laZRgwrZ6jIFPWlAqAKGRUYN9TYqGaoKAZn15YJOIaol+YIWHcEOhikOokVG0n1e9plW2oEWokUWYf4mAYHd4YJGKbJGHZX91VQDYzXS0p3a+sYnKvZDGuY/Euo6/tozNwJSsso6uqoi3sZC4spS2sJCvqoiwto/Tx5rNwZXNw5bQxZfNw5fk7m3vjdoQDQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "A miniverse, from Rick and Morty",
            "title": "A miniverse, from Rick and Morty",
            "src": "/static/106733e904a7d41252442d899c5c2e97/0a47e/miniverse.png",
            "srcSet": ["/static/106733e904a7d41252442d899c5c2e97/8a4e8/miniverse.png 150w", "/static/106733e904a7d41252442d899c5c2e97/5a46d/miniverse.png 300w", "/static/106733e904a7d41252442d899c5c2e97/0a47e/miniverse.png 600w", "/static/106733e904a7d41252442d899c5c2e97/1cfc2/miniverse.png 900w", "/static/106733e904a7d41252442d899c5c2e97/c1b63/miniverse.png 1200w", "/static/106733e904a7d41252442d899c5c2e97/29114/miniverse.png 1920w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`A miniverse, from Rick and Morty`}</figcaption>{`
  `}</figure>
    <h1>{`Use Conda for Everything`}</h1>
    <p>{`I've found a lot packages in anaconda shopping mall: `}<strong parentName="p">{`zsh, clang, cmake, libtool, autoconfig, nodejs, ruby, openjdk`}</strong>{`... all linux toolchains and packages you could image. Vendor like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conda-forge`}</code>{` makes a lot of recipes, got to check it out. Next time when you want to `}<em parentName="p">{`brew/apt/yum install`}</em>{`, you should first check if you can do it in conda elegantly. The good things is that you don't need to messing around with folders like `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/usr/bin`}</code>{` etc. and you can easily revert to your previous install revisions. Excited by this finding, I've migrated all my old install `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/experimental/installConda.sh"
      }}>{`scripts`}</a>{` just to use conda so that my environment is more independent.`}</p>
    <h1>{`What? no recent neovim?`}</h1>
    <p>{`In anaconda, I can only find python package instead of native neovim app I need. There are some native neovim build but mostly outdated. One of the greatest things about conda ecosystem is: if some package's missing, you can build it from source and then share it on Anaconda store. Everyone else benefits by saving a lot of build/release time.
Build conda packages is so `}<a parentName="p" {...{
        "href": "http://mlg.eng.cam.ac.uk/hoffmanm/blog/2016-02-25-conda-build/"
      }}>{`easy`}</a>{`. Always remember `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conda-forge`}</code>{` is one of the most resourceful channels. After some searching, you could write your first build `}<a parentName="p" {...{
        "href": "script"
      }}>{`script`}</a>{` for neovim quickly. Then you just do:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`conda build nvim `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-c`}</span>{` conda-forge`}</code></pre></div>
    <p>{`Later install this package locally. In my case, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`--use-local`}</code>{` doesn't work, so I used this one.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`conda install -c file://\${CONDA_PREFIX}/conda-bld/<PACKAGENAME>`}</code></pre></div>
    <p>{`When build is working, you could upload it for example:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`anaconda login `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`# you need: conda install anaconda-client`}</span>{`
anaconda upload `}<span parentName="code" {...{
            "className": "token variable"
          }}>{`\${CONDA_PREFIX}`}</span>{`/conda-bld/linux-64/nvim-0.3.1-0.tar.bz2 `}</code></pre></div>
    <p>{`Of course, you can do better using `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Continuous_integration"
      }}>{`CI`}</a>{` like `}<a parentName="p" {...{
        "href": "https://travis-ci.org/"
      }}>{`Travis`}</a>{` to automate releasing of all platforms. You can also push your recipe to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conda-forge`}</code>{` for publish like `}<a parentName="p" {...{
        "href": "https://gist.github.com/zshaheen/fe76d1507839ed6fbfbccef6b9c13ed9"
      }}>{`here`}</a>{` or `}<a parentName="p" {...{
        "href": "https://gist.github.com/yoavram/05a3c04ddcf317a517d5"
      }}>{`here`}</a></p>
    <p>{`So now everyone who wants neovim in conda could do this in Linux/OSX, 🙌: `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`conda `}<span parentName="code" {...{
            "className": "token function"
          }}>{`install`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-y`}</span>{` `}<span parentName="code" {...{
            "className": "token parameter variable"
          }}>{`-c`}</span>{` daizeng1984 nvim`}</code></pre></div>
    <h1>{`Revisit My Previous Projects`}</h1>
    <p>{`If you worked with Python before, you must remember the nightmare with Python's native dependencies e.g. `}<strong parentName="p">{`BLAS, OpenLdap, Cyrus-Sasl`}</strong>{` etc.. One of my python neovim plugin also has hard-to-get dependency. This sucks and frustrates a lot since we are advertised Python is very cross-platformy. Now with conda, you have more confidence to install all dependencies using merely `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conda install`}</code>{`. There are still some Python packages (pip) or outlaws that don't respect conda, and blindly complains about e.g. missing lib's headers. In this case, we need keep the build folder (--no-clean), add lib and include locations in `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`setup.cfg`}</code>{` and reinstall. `}</p>
    <p>{`For example, my neovim plugin `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/vim-snip-and-paste"
      }}>{`Snip-n-Paste`}</a>{`, requires `}<a parentName="p" {...{
        "href": "https://pygobject.readthedocs.io/en/latest/getting_started.html"
      }}>{`pygobject`}</a>{` which usually took quite some time to get it right, but now it's simply: `}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "condainstall -c pkgw-forge -c conda-forge gtk3 pygobject"
    }}><pre parentName="div" {...{
        "className": "language-condainstall -c pkgw-forge -c conda-forge gtk3 pygobject"
      }}><code parentName="pre" {...{
          "className": "language-condainstall -c pkgw-forge -c conda-forge gtk3 pygobject"
        }}></code></pre></div>
    <p>{`Another example is installing the servers for LanguageClient e.g. cquery.`}</p>
    <h1>{`Cons?`}</h1>
    <p>{`You got me, not perfect at everything, just for open *nix packages. You cannot install OS dependent app e.g. mac store app etc.. There are also some boundaries if you have some outlaw (mostly native code related) apps, e.g. `}<a parentName="p" {...{
        "href": "https://matplotlib.org/faq/osx_framework.html"
      }}>{`maplot`}</a>{`. In these case, you're still limited to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`brew install`}</code>{`, but maybe think about: do you really need these not very portable `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`bad guys`}</code>{`?`}</p>
    <p>{`conda might as well have issues with versions consistency. You need to choose the reliable channel. But again, when messed up, you can always revert back. To minimize these issues, I'd stick to `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`conda-forge`}</code>{` channel for all dependencies and when necessary, build my own. Therefore, for my conda experience so far, so good.`}</p>
    <p>{`Of course, conda is not alone. For *nix environment, `}<a parentName="p" {...{
        "href": "https://nixos.org/nix/"
      }}>{`Nix`}</a>{` as another package manager claims to be as cool as it and it seems to gain a lot of attention recently. However, no matter your choice, it's good to make your development environment as independent as possible.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      